<template>
  <div
    :class="[
      'flex min-w-10 items-center justify-center space-x-1 rounded-full px-2 py-px text-xs',
      colourClass,
    ]"
  >
    <template v-if="percentageChange === Infinity">
      -
    </template>
    <template v-else>
      <IconArrowDown v-if="percentageChange < 0" />
      <IconArrowUp v-else />
      <span>{{
        formatToPercentage(percentageChange)
      }}</span>
    </template>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  percentageChange: number
}>()

const colourClass = computed(() =>
  props.percentageChange === Infinity
    ? "bg-info/10 text-info"
    : props.percentageChange >= 0
      ? "bg-positive/10 text-positive"
      : "bg-error/10 text-error"
)
</script>
